import React, { useEffect, useRef } from "react";

export const Header = (props) => {
  const {
    title,
    paragraph,
    hideButton = false,
    backgroundImage
  } = props.data || {};

  const headerRef = useRef(null);

  useEffect(() => {
    // Preload background image for faster display
    if (backgroundImage) {
      const img = new Image();
      img.src = backgroundImage;
    }
  }, [backgroundImage]);

  const headerStyle = {
    minHeight: "75vh",
    display: "flex",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "scroll",
    position: "relative",
  };

  // If there's a background image, apply it with optimization
  if (backgroundImage) {
    headerStyle.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${backgroundImage})`;
  } else {
    headerStyle.backgroundColor = "#f5f5f5";
  }

  return (
    <header id="header" ref={headerRef}>
      <div className="intro" style={headerStyle}>
        <div className="overlay" style={{ width: "100%" }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">

                <div className="animated-heading">
                  <h1>
                    {title || "Loading"}
                  </h1>
                </div>

                <p
                  style={{
                    paddingTop: "20px",
                    fontSize: "32px",
                    lineHeight: "40px",
                    color: "#f5f5f5"
                  }}
                >
                  {paragraph || "Loading"}
                </p>

                {!hideButton && (
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

